// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
} from '../../utils/Styles/DataBoxStyles';

const AccomodationListMobile = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  events,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  tz,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  handleOnClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  getReservationDates,
}) => {
  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {events.map(event => {
        const { checkIn, checkOut } = getReservationDates(event, tz);
        return (
          <StyledMobileBoxItem
            key={event.eventId}
            data-eventId={event.eventId}
            onClick={handleOnClick}
          >
            <StyledMobileBoxItemRow>{event.eventName}</StyledMobileBoxItemRow>
            <StyledMobileBoxItemRow>
              {checkIn} - {checkOut}
            </StyledMobileBoxItemRow>
          </StyledMobileBoxItem>
        );
      })}
    </div>
  );
};

export default AccomodationListMobile;
